import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export interface UserPermissionInsDelState {
    state: LoadStateInfo;
    request?: ExecuteUserPermissionInsDelRequest;
}

const initialState: UserPermissionInsDelState = {
    state: notStarted(),
};

export interface ExecuteUserPermissionInsDelRequest {
    userId: string;
    targetId: string;
    permissionId: string;
    action: "ins" | "del";
}

export const executeUserPermissionInsDel = createAsyncThunk(
    "executeUsersPermissionInsDel",
    async (params: ExecuteUserPermissionInsDelRequest, thunkAPI) => {
        console.debug(`Execute permission ${params.permissionId} for user ${params.userId} on target ${params.targetId} action ${params.action}`);

        const response = await fetch(`${getBackendUrl()}/api/user/${params.userId}/permission/${params.permissionId}/target/${params.targetId}`, {
            method: params.action == "ins" ? "POST" : "DELETE",
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
            }
        });

        if (response.ok) {
            return "Ok";
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    }
);

export const userPermissionInsDelSlice = createSlice({
    name: "usersPermissionInsDelSlice",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(executeUserPermissionInsDel.pending, (state, action) => {
                state.state = loading();
                state.request = action.meta.arg;
            })
            .addCase(executeUserPermissionInsDel.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
            })
            .addCase(executeUserPermissionInsDel.rejected, (state, action) => {
                state.state = error(action);
            });
    },
});

export const { } = userPermissionInsDelSlice.actions;

export const selectUserPermissionInsDel = (state: RootState) => state.userPermissionInsDel;

export default userPermissionInsDelSlice.reducer;
